import type {SystemStyleObject} from '@chakra-ui/styled-system';
import {deepmerge} from 'deepmerge-ts';

export const mergeSXProp = (baseSXProp: SystemStyleObject, propertiesToMerge: SystemStyleObject = {}) => {
  return deepmerge({}, baseSXProp, propertiesToMerge);
};
